import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { ApiUrl } from '../../custom-services/api-url/api-url';
import { ApiService } from '../../custom-services/ApiService';
// import { navItems } from '../../_nav';
import { getNavItems } from '../../side-bar-menu';
import { DataService } from '../../service/data.service';

import { CommonUtilService } from '../../service/utils/common-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from '../../service/auth.service';
import { clearAuditedAccountsSessionSelection } from '../../audited-accounts/audited-accounts-session.util';

type MaintenancePhase = 'pre-maintenance' | 'during-maintenance';

@Component({
    selector: 'app-layout',
    templateUrl: './default-layout.component.html',
    styleUrls: ['./default-layout.component.css'],
    standalone: false
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  private static readonly MAINTENANCE_START = new Date('2026-10-01T00:00:00+06:00');
  private static readonly MAINTENANCE_END = new Date('2026-10-01T00:30:00+06:00');

  showMaintenanceSection = false;
  maintenancePhase: MaintenancePhase = 'pre-maintenance';
  maintenanceCountdown = '00:00:00';

  private maintenanceTimerInterval: ReturnType<typeof setInterval>;

  public sidebarMinimized = false;
  public navItems = getNavItems(); // Initialize with default

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  userTin: any;
  data: any;

  apiService: ApiService;
  apiUrl: ApiUrl;
  taxpayerProfileImg: any;
  taxpayerName: any;
  taxpayerTIN: any;

  hasImage: boolean = true;
  routerSubscription:any;
  baseUrl:string = environment.taxpayer_base_url;
  amendmentEligibilityCheckPath: string = '/filingservice/v3/api/amendment/check-eligibility';

  allAssessmentYearApiPath: string = '/filingservice/v3/api/assessment-year/get-all';
  assessmentYearApiPath: string = '/filingservice/v3/api/assessment-year/get';
  setAssessmentYearApiPath: string = '/filingservice/v3/api/assessment-year/set/';

  amendmentConfirmed: boolean = false;

  assessmentYearList: {name: string, year: string}[];
  currentAssessmentYear:string;
  previousAssessmentYear: string;

  modalRef: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: true,
    animated: false
  };

  constructor(private router: Router,
    apiService: ApiService,
    apiUrl: ApiUrl,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer,
    private dataSource: DataService,
    private authService: AuthService,

    private modalService: BsModalService,
  ) {
    this.apiService = apiService;
    this.apiUrl = apiUrl;
  }

  ngOnInit(): void {
    this.updateMaintenanceSection();
    this.maintenanceTimerInterval = setInterval(() => this.updateMaintenanceSection(), 1000);

    this.userTin = localStorage.getItem('tin');
    this.taxpayerProfileImg = '';
    this.getData();

    this.checkAmendmentEligibility()

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.handleActiveMenuBasedOnRouting();
      }
    });

    this.dataSource.data$.subscribe(data=>{
      this.amendmentConfirmed = data.get('AMENDMENT_CONFIRMED');
      this.currentAssessmentYear = data.get('CURRENT_ASSESSMENT_YEAR');
      this.assessmentYearList = data.get('ASSESSMENT_YEAR_LIST');

      // Update nav items when assessment year changes
      if (this.currentAssessmentYear) {
        this.navItems = getNavItems(this.currentAssessmentYear);
      } else {
        // Check if user is still authenticated before making API call
        if (this.authService.loggedIn()) {
          this.getCurrentAssessmentYear();
        }
      }
    })

    this.getAssessmentYearList();
  }

  getAssessmentYearList():void{
    this.apiService.get(this.baseUrl + this.allAssessmentYearApiPath)
    .subscribe(res=>{
      this.dataSource.updateData('ASSESSMENT_YEAR_LIST',res?.replyMessage?.assessmentYearList);
      this.getCurrentAssessmentYear();
    })
  }

  getCurrentAssessmentYear(): void{
    this.apiService.get(this.baseUrl + this.assessmentYearApiPath)
    .subscribe(res=>{
      const currentAY = CommonUtilService.toNormalAssessmentYearFormat(res?.replyMessage?.AY);
      this.dataSource.updateData('CURRENT_ASSESSMENT_YEAR',currentAY);
      this.previousAssessmentYear = currentAY;
      localStorage.setItem('CURRENT_ASSESSMENT_YEAR',currentAY);
      this.navItems = getNavItems(currentAY);
    },
    error=>{
    })
  }

  onChangeAssessmentYear(event: any, changeAssessmentYear) {
    this.modalRef = this.modalService.show(changeAssessmentYear, this.config);
  }

  cancelChangeAssessmentYear(){
    this.currentAssessmentYear = this.previousAssessmentYear;
    this.modalRef.hide();
  }

  changeAssessmentYearFn(){
    const apiAssessmentYear = CommonUtilService.toApiAssessmentYearFormat(this.currentAssessmentYear);

    this.apiService.post(this.baseUrl + this.setAssessmentYearApiPath + apiAssessmentYear,{})
    .subscribe(res=>{
      this.modalRef.hide();

      this.toastr.success(`Assessment Year ${this.currentAssessmentYear} has been set successfully`,'',{timeOut: 3000});
      this.dataSource.updateData('CURRENT_ASSESSMENT_YEAR',this.currentAssessmentYear);
      localStorage.setItem('CURRENT_ASSESSMENT_YEAR',this.currentAssessmentYear);
      this.previousAssessmentYear = this.currentAssessmentYear;
      this.router.navigate(['/user-panel/home']);
      setTimeout(()=>{
        location.reload();
      })
    },
    error=>{

      this.cancelChangeAssessmentYear();
    })
  }

  checkAmendmentEligibility(){
    this.apiService.get(this.baseUrl + this.amendmentEligibilityCheckPath)
    .subscribe(res=>{
      this.amendmentConfirmed = res.confirmationStatus == 'CONFIRMED' ? true : false;
      this.dataSource.updateData('AMENDMENT_CONFIRMED',this.amendmentConfirmed)
      this.handleActiveMenuBasedOnRouting();
    })
  }

  handleActiveMenuBasedOnRouting(){
    const regularReturnMenuElement = document.querySelector('.regular-return-menu a');
    const amendmentReturnMenuElement = document.querySelector('.amendment-return-menu a');
    const exactPath = this.extractSubPaths(this.router.url);

    if(exactPath === 'additional-information' || exactPath === 'employment'
      || exactPath === 'financial-assets' || exactPath === 'rent' || exactPath === 'agriculture'
      || exactPath === 'firm-etc' || exactPath === 'business' || exactPath === 'capital-gain' || exactPath === 'assets-and-liabilities'
      || exactPath === 'income-from-other-sources' || exactPath === 'tax-exempted-income' || exactPath === 'rebate'
      || exactPath === 'expenditure' || exactPath === 'tax-and-payment' || exactPath === 'post-sub-return-view' || exactPath === 'voluntary-disclosure-income'){
      if(this.amendmentConfirmed){
        amendmentReturnMenuElement?.classList.add('active');
        regularReturnMenuElement?.classList.remove('active');
      }
      else{
        setTimeout(()=>{
          regularReturnMenuElement?.classList.add('active');
          amendmentReturnMenuElement?.classList.remove('active');
        },100)
      }
    }
    else if(exactPath === 'assessment/regular-return'){
      amendmentReturnMenuElement?.classList.remove('active');
    }
    else if(exactPath === 'assessment/amendment-return' || exactPath === 'amendment-return'){
      setTimeout(()=>{
        amendmentReturnMenuElement?.classList.add('active');
      },100)
      regularReturnMenuElement?.classList.remove('active');
    }
    else{
      amendmentReturnMenuElement?.classList.remove('active');
      regularReturnMenuElement?.classList.remove('active');
    }
  }

  extractSubPaths(url: string):string {
    const segments = url.split('/').filter(Boolean);
    const userPanelIndex = segments.indexOf('user-panel');
    return userPanelIndex !== -1 ? segments.slice(userPanelIndex + 1).join('/') : ''
  }

  getData() {
    this.apiService.get(environment.taxpayer_base_url + '/filingservice/v3/api/user-panel/taxpayer-profile/short')// + this.userTin)
      .subscribe(result => {
        if (JSON.stringify(result) != '{}') {
          this.data = result;
          this.taxpayerProfileImg = this.data.image == null || this.data.image == "" ? "No image found"
            : this.imgTransform();
          this.taxpayerName = this.data.assesName;
          this.taxpayerTIN = this.data.tin;

          if (this.taxpayerProfileImg == "No image found") {
            this.hasImage = false;
          }
        }
      },
        error => {
        });
  }

  imgTransform() {
    return 'data:image/jpg;base64,' + (this.sanitizer.bypassSecurityTrustResourceUrl(this.data.image) as any).changingThisBreaksApplicationSecurity;
  }

  logOut() {
    this.apiService.post(environment.taxpayer_base_url + '/authenticationservice/v3/api/logout',"")
    .subscribe(result => {
        if(result.success)
        {
          this.dataSource.updateData('MODULE_ASSESSMENT_YEAR', '');
          clearAuditedAccountsSessionSelection();
          localStorage.clear();
          this.router.navigate(["/auth/sign-in"]);
        }
    }, error => {
      clearAuditedAccountsSessionSelection();
      localStorage.clear();
      this.router.navigate(["/auth/sign-in"]);
    })
  }

  ngOnDestroy() {
    if (this.maintenanceTimerInterval) {
      clearInterval(this.maintenanceTimerInterval);
    }

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private updateMaintenanceSection(): void {
    const now = new Date();

    if (now >= DefaultLayoutComponent.MAINTENANCE_END) {
      this.showMaintenanceSection = false;
      return;
    }

    this.showMaintenanceSection = true;

    if (now >= DefaultLayoutComponent.MAINTENANCE_START) {
      this.maintenancePhase = 'during-maintenance';
      this.setMaintenanceCountdown(DefaultLayoutComponent.MAINTENANCE_END, now);
    } else {
      this.maintenancePhase = 'pre-maintenance';
      this.setMaintenanceCountdown(DefaultLayoutComponent.MAINTENANCE_START, now);
    }
  }

  private setMaintenanceCountdown(target: Date, now: Date): void {
    const diff = Math.max(0, target.getTime() - now.getTime());
    const hours = Math.floor(diff / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    this.maintenanceCountdown = [
      hours.toString().padStart(2, '0'),
      minutes.toString().padStart(2, '0'),
      seconds.toString().padStart(2, '0'),
    ].join(':');
  }
}
